import React, {FunctionComponent} from "react";
import {CameraRoll, InsertDriveFile} from "@mui/icons-material";
import {TreeItem} from "@mui/lab";
import {Box, Typography} from "@mui/material";
import {IFileSystemContent} from "./content/FileSystemContent";

const icons: {[key: string]: FunctionComponent<any>} = {
    "default": InsertDriveFile,
    "video/iso.segment": CameraRoll,
    "video/mp4": CameraRoll,
    "video/quicktime": CameraRoll
}

export interface IMetadata {
    contentType?: string
    customMetadata?: any,
    size: number,
    source?: string
    timeCreated: string
}

interface IProps {
    content: IFileSystemContent
    onSelected: (selected: string) => void
    path: string
}
export function FileItem ({content, onSelected, path}: IProps) {
    const file = content.getFile(path);
    
    if (! file) return null;
    
    const icon = icons[file.contentType] || icons.default;
    return (
        <TreeItem key={path} nodeId={path} label={
            <Box display="flex" m={1}>
                {React.createElement(icon, {color: "disabled", fontSize: "small", sx: {marginRight: 1}})}
                <Typography variant="body2">{file.name}</Typography>
            </Box>
        } onClick={() => {
            onSelected(path);
        }}/>
    );
}
